export interface BulkRecursiveRecipeInformationDetails {
  stockId: number,
  recipeId: number,
  recipeDetailId: number,
  recipeDetailIdAmount: number, // amount of the recipeDetailId
  allergenId: number,
  allergenName: string,
  dietId: number,
  dietName: string,
  hasSulphur: boolean,
  hasCelery: boolean,
  hasCereal: boolean,
  saturatedFat: number,
  transFat: number,
  cholesterol: number,
  sodium: number,
  dietaryFiber: number,
  sugars: number,
  protein: number,
  calories: number,
  energy: number,
  carbohydrate: number
}

export type GenericIdName = {
  id: number,
  name: string
}

export type NutritionDetails = {
  saturatedFat: number,
  transFat: number,
  cholesterol: number,
  sodium: number,
  dietaryFiber: number,
  sugars: number,
  protein: number,
  calories: number,
  energy: number,
  carbohydrate: number
}

export interface RecipeInformationDetails {
  allergens: GenericIdName[],
  diets: GenericIdName[],
  hasSulphur: boolean,
  hasCelery: boolean,
  hasCereal: boolean
}